// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import BarGraph from './pages/BarGraph';
import ExcelUploadPage from './pages/UploadExcelPage';
import PlacementsPieChart from './pages/PlacementsPieChart';
import ExcelDownloadPage from './pages/ExcelDownloadPage';
import LoginPage from './pages/LoginPage';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkUserLoggedIn = () => {
      const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true';
      setIsLoggedIn(isAuthenticated);
    };

    checkUserLoggedIn();
  }, []);

  return (
    <div className="container-fluid" style={{ overflow: 'hidden', height: '100vh' }}>
      <Router>
        <Switch>
          <Route exact path="/" render={() => <BarGraph />} />
          <Route path="/piechart" component={PlacementsPieChart} />
          <Route path="/testdata" component={ExcelDownloadPage} />
          <Route
            path="/login"
            render={() => <LoginPage isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />}
          />
          <PrivateRoute
            path="/dashboard"
            component={ExcelUploadPage}
            isLoggedIn={localStorage.getItem('isLoggedIn') === 'true'}
          />
        </Switch>
      </Router>
    </div>
  );
};

const PrivateRoute = ({ component: Component, isLoggedIn, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default App;
